import GenericRequest, { METHOD_GET } from '../../../../../shared/webservices/GenericRequest';

export class MachineDetailTask extends GenericRequest {

    _request; // MachineDetailRequest

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/update/machine-detail/MachineDetailTask.js